import React from "react";
import { useIntl } from "react-intl";
import cn from "classnames";
import { Link } from "react-router-dom";

import routing from "../../routing";

import Seo from "../../../common/helpers/seo";

import { StyledTerms } from "./styles";

const Terms = () => {
    const { locale } = useIntl();
    return (
        <StyledTerms marginTop={50} as="section" className={cn("spring--shadow")}>
            <Seo title={locale === "hu" ? "Felhasználási feltételek" : "Terms of usage"} type="article" />
            {locale === "hu" ? (
                <>
                    <h1>FELHASZNÁLÁSI FELTÉTELEK</h1>
                    <h2>1. A Weboldal használatára vonatkozó általános rendelkezések</h2>
                    <p>
                        A Musicators webalkalmazást (a továbbiakban: Webalkalmazás) és az azzal összefüggő szolgáltatásokat
                        (a továbbiakban együttesen: Weboldal, Szolgáltatás) Bali Dániel és Dr. Molnár Dániel (a továbbiakban
                        együttesen: Szolgáltató) üzemelteti. Az itt leírt általános használati feltételek (a továbbiakban:
                        Használati Feltételek) szabályozzák a jelen Szolgáltatással működtetett Webalkalmazás felhasználók
                        által történő használatát. A Szolgáltatás bármely részéhez való hozzáférésével, illetve
                        használatával Ön tudomásul veszi, hogy a jelen Használati Feltételekben foglalt rendelkezéseket,
                        valamint azok esetleges jövőbeli módosításait elolvasta, megértette, és azokat kifejezetten önmagára
                        nézve kötelező érvényűnek fogadja el. A Szolgáltatónak joga van a Használati Feltételek
                        megváltoztatására, frissítésére, illetve kicserélésére – ilyen változtatás esetén a Felhasználót
                        értesíti, mikor az legközelebb az oldalra érkezik, valamint feltünteti az érvényes Használati
                        Feltételek utolsó frissítésének dátumát. Amennyiben Ön nem ért egyet a jelen Használati
                        Feltételekben foglalt rendelkezések tartalmával, Ön nem jogosult a Szolgáltatáshoz való
                        hozzáférésre, illetve annak használatára.
                    </p>
                    <h2>2. A Webalkalmazás és a Szolgáltatás leírása</h2>
                    <p>
                        A Webalkalmazás segítségével a Felhasználó (továbbiakban Tanár) tartalmakat hozhat létre. A
                        Webalkalmazás használata folyamán a Tanár különféle feladatokat oldat meg a diákjaival (továbbiakban
                        Tanulók), melyek mindig egy bizonyos dal vagy zenemű köré szerveződnek. A feladatok megoldása során
                        a Tanár megismerteti a zenei anyagot a Tanulókkal saját pedagógiai elveinek megfelelően. A
                        jogszabályi háttér 14 éven aluli Tanulók számára csak a Tanár felügyeletével teszi lehetővé a
                        Webalkalmazás használatát. Az adatvédelmi rendelkezésekről a továbbiakban <Link className={"link"} to={`${routing.privacy}`}>itt</Link> olvashat.
                    </p>
                    <h2>3. Regisztráció</h2>
                    <p>
                        A Szolgáltatás igénybevételéhez szükséges regisztrációval a Felhasználó beleegyezik abba, hogy
                        önmagáról pontos és aktuális információt köteles szolgáltatni – a regisztrációs kérdőívnek
                        megfelelően; köteles gondoskodni a jelszavának, illetve a regisztrációval létrehozott profil
                        biztonságához szükséges információknak bizalmasságáról; valamint a regisztrációval létrehozott
                        profilban foglalt adatokat a valóságnak megfelelően folyamatosan frissíti.
                    </p>
                    <p>
                        Szolgáltató a Szolgáltatás átmeneti vagy végleges szünetelése miatt, illetve a Szolgáltató által
                        kezelt adatok részleges vagy teljes elvesztése miatt semmilyen felelősséget nem vállal.
                    </p>
                    <h2>4. Szerzői jogok</h2>
                    <p>
                        A Weboldal egésze, annak grafikus elemei, szövege és technikai megoldásai, és a Szolgáltatás elemei
                        szerzői jogi védelem vagy más szellemi alkotáshoz fűződő jog alatt állnak. Szolgáltató a szerzői
                        jogi jogosultja vagy a feljogosított felhasználója a Weboldalon, valamint a Weboldalon keresztül
                        elérhető szolgáltatások nyújtása során megjelenített valamennyi tartalomnak: bármely szerzői műnek,
                        illetve más szellemi alkotásnak (ideértve többek közt valamennyi grafikát és egyéb anyagokat, a
                        Weboldal felületének elrendezését, szerkesztését, a használt szoftveres és egyéb megoldásokat,
                        ötletet, megvalósítást).
                    </p>
                    <p>
                        A Weboldal tartalmának valamint egyes részeinek fizikai vagy más adathordozóra mentése vagy
                        kinyomtatása magáncélú felhasználás céljából vagy a Szolgáltató előzetes írásbeli hozzájárulása
                        esetén engedélyezett. A magáncélú felhasználáson túli felhasználás – például adatbázisban történő
                        tárolás, továbbadás, közzé- vagy letölthetővé tétel, kereskedelmi forgalomba hozatal – kizárólag a
                        Szolgáltató előzetes írásbeli engedélyével lehetséges.
                    </p>
                    <p>
                        A jelen Használati Feltételekben kifejezetten meghatározott jogokon túlmenően a regisztráció, a
                        Szolgáltatás használata, illetve a Használati Feltételek egyetlen rendelkezése sem biztosít jogot a
                        Felhasználónak a Weboldalon szereplő bármely kereskedelmi névnek vagy védjegynek bármely
                        használatára, hasznosítására. A Szolgáltatás rendeltetésszerű használatával járó megjelenítésen, az
                        ehhez szükséges ideiglenes többszörözésen és a magáncélú másolatkészítésen túl e szellemi alkotások
                        a Szolgáltató előzetes írásbeli engedélye nélkül semmilyen egyéb formában nem használhatók fel vagy
                        hasznosíthatók.
                    </p>
                    <h2>5. Adatvédelem</h2>
                    <p>
                        A Szolgáltatás igénybevételére, illetve használatára vonatkozó magatartási szabályok a Weboldalon
                        elérhető Adatvédelmi Szabályzat hatálya alá is tartoznak, amely{" "}
                        <Link className={"link"} to={"/" + routing.privacy}>
                            ide kattintva
                        </Link>{" "}
                        érhető el. A Szolgáltatás használatával a Felhasználó elfogadja az Adatvédelmi Szabályzatban
                        foglaltakat is.
                    </p>
                    <h2>6. A Weboldalon a Felhasználó által közzétett tartalom</h2>
                    <h3>6.1. Zeneművek és hangfelvételek szerzői jogsértének kezelése</h3>
                    <p>
                        A Weboldalon az egyes szolgáltatások megfelelő igénybevételéhez szükséges lehet kottagrafika
                        feltöltése. A Felhasználónak kötelessége garantálni, hogy a feltöltés és ennek következtében a kotta
                        tárolása nem von maga után jogsértést sem a zeneszerzőt, sem a kottakiadót illetően. Ugyanez
                        vonatkozik a feltöltött zenefájlokra és a bevitt dallamokra is. A nem publikus tartalmakat nincs
                        lehetőségünk folyamatosan szűrni, viszont a megosztott tartalmakat bizonyos időközönként
                        átvizsgáljuk és jogsértés gyanúja esetén a tartalmat a lehető leghamarabb eltávolítjuk. Rendszeres
                        próbálkozás jogi lépéseket vonhat maga után, illetve fenntartjuk a jogot, hogy ennek következtében a
                        Felhasználó fiókját deaktiváljuk.
                    </p>
                    <h3>6.2. A Felhasználó által közzétett tartalmak kezelése</h3>
                    <p>
                        A Felhaszáló által készített tartalmakat a Szolgáltató 14 nap után közzéteheti a Webalkalmazás
                        publikus felületein. Ezen tartalmakat más felhasználók és a Webalkalmazás oldalára látogatók is
                        láthatják. Más felhasználók alapesetben lemásolhatják és módosíthatják ezen tartalmakat. Ez
                        megváltoztatható a feladatsor megosztás ablakában. A tartalom mindaddig listázott lesz, amíg a
                        Felhasználó nem törli azt. Felhasználói fiók törlése esetén a Felhasználó tartalmai automatikusan
                        törlődnek, kivéve a listázott feladatsorok, melyek anoním feladatsorokká valóságnak!
                    </p>
                    <p>
                        A Felhasználó a Szolgáltatás használatával beleegyezik, hogy lemond az általa közzétett tartalom
                        felhasználási jogáról és nem tart igényt az azokból származó esetleges haszonra.
                    </p>
                    <h2>7. Az oldalakon megjelenő hirdetések</h2>
                    <p>
                        Az oldalon hirdetések jelennek meg az oldal fenntartásához. Ehhez a Google LLC (1600 Amphitheatre
                        Parkway, Mountain View, CA 94043 United States;{" "}
                        <a
                            className="link"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://policies.google.com/privacy?hl=en"
                        >
                            további információ
                        </a>
                        ) segítségét vesszük igénybe. A Google cookie-kat használ a webhelyen megjelenő hirdetések
                        megjelenítésének támogatására, például a Google-hirdetéseket megjelenítő vagy a Google által
                        jóváhagyott hirdetési hálózatokban részt vevő webhelyek hirdetéseinél. Amikor a Felhasználó
                        felkeresi egy Google-partner webhelyét, a végfelhasználó böngészőjébe cookie töltődhet le. A Google
                        cookie-k használatával jelenítenek meg hirdetéseket, a felhasználónak a webhelyét vagy más
                        webhelyeket érintő korábbi látogatásai alapján. A Google által használt hirdetési cookie-k lehetővé
                        teszik, hogy a Google és partnerei a hirdetéseket a webhelyen és az internet egyéb webhelyein tett
                        látogatásaik alapján jelenítsék meg a felhasználók számára. A felhasználók leiratkozhatnak a
                        személyre szabott hirdetésekről a Hirdetésbeállítások oldal felkeresésével, illetve a
                        www.aboutads.info oldalon leiratkozhatnak arról is, hogy a személyre szabott hirdetésekhez a külső
                        szolgáltatók cookie-kat használhassanak.
                    </p>
                    <p>Utoljára frissítve: 2020. április. 4.</p>
                </>
            ) : (
                <div lang="en">
                    <h1>TERMS OF USAGE</h1>
                    <h2>1. General Terms of Usage for the Website</h2>
                    <p>
                        The Musicators Web Application ("Web Application") and related services (collectively: "Website",
                        "Service") are operated by Daniel Bali and Daniel Molnar PhD (collectively: "Service Provider"). The
                        general terms of usage described herein ("Terms of Usage") govern your use of the Web Application
                        hosted by this Service. By accessing or using any part of the Service, you acknowledge that you have
                        read, understood and agree to be bound by the terms of these Terms of Service and any future changes
                        thereto. The Service Provider has the right to change, update or replace the Terms of Usage - in the
                        event of such a change, it will notify the User the next time it arrives at the site and indicate
                        the date of last update of the applicable Terms of Usage. If you do not agree with the terms of
                        these Terms of Usage, you are not entitled to access or use the Service.
                    </p>
                    <h2>2. Description of the Web Application and the Service</h2>
                    <p>
                        The Web Application enables the User (hereinafter referred to as the Teacher) to create content.
                        During the use of the Web Application, the Teacher solves a variety of tasks with his / her students
                        (hereafter referred to as Students), which are always organized around a particular song or piece of
                        music. In solving these problems, the Teacher introduces the music to the Students in accordance
                        with their own pedagogical principles. The legal background allows students under the age of 14 to
                        use the Web Application only under the supervision of a Teacher. You can read more about the privacy
                        policy <Link className={"link"} to={`/${routing.privacy}`}>here</Link>.
                    </p>
                    <h2>3. Sign up</h2>
                    <p>
                        By registering for the Service, the User agrees to provide accurate and current information about
                        himself / herself - in accordance with the registration questionnaire; be required to maintain the
                        confidentiality of your password and of the information required to maintain the security of your
                        profile; and the information contained in the profile created by registration will be kept up to
                        date.
                    </p>
                    <p>
                        The Service Provider shall not be liable for any temporary or permanent interruption of the Service
                        or for the total or partial loss of data managed by the Service Provider.
                    </p>
                    <h2>4. Copyrights</h2>
                    <p>
                        The entire Website, its graphic elements, text and technical solutions, and the elements of the
                        Service are protected by copyright or other intellectual property rights. Service Provider is the
                        copyright holder or its authorized user of all content displayed on the Website and the Services
                        available through the Website: any copyright or other intellectual work (including but not limited
                        to all graphics and other materials, layout, editing, used software and other solutions, ideas,
                        implementations).
                    </p>
                    <p>
                        It is permitted to save or print the contents of the Website or parts thereof on physical or other
                        media for private use or with the prior written consent of the Service Provider. Any use beyond
                        private use, such as storage, retransmission, publication or download, or commercialization, is
                        permitted only with the prior written permission of the Service Provider.
                    </p>
                    <p>
                        Except as expressly set forth in these Terms of Usage, nothing in the registration, use of the
                        Service, or any provision of the Terms of Usage gives you the right to use any trade name or
                        trademark of the Website. Except for the purpose of displaying the Service, its intended temporary
                        reproduction and private copying, these intellectual works may not be used or exploited in any way
                        without the prior written permission of the Service Provider.
                    </p>
                    <h2>5. Data protection</h2>
                    <p>
                        The Code of Conduct for using the Service is also subject to the Privacy Policy available on the
                        Website, which can be accessed by clicking{" "}
                        <Link className={"link"} to={"/" + routing.privacy}>
                            here
                        </Link>
                        . By using the Service, you also agree to the terms of this Privacy Policy.
                    </p>
                    <h2>6. Content posted by the User on the Website</h2>
                    <h3>6.1. Managing copyright infringement of music compositions and recordings</h3>
                    <p>
                        You may need to upload sheet music graphics in order to use certain services on the Website. It is
                        the User's responsibility to guarantee that uploading and storing the score will not constitute an
                        infringement for either the composer nor the publisher. The same applies to uploaded music files and
                        input melodies. We are not able to continuously filter unpublished content, but we will periodically
                        review shared content and remove it as soon as possible in the event of a violation. Regular
                        attempts may result in legal action and we reserve the right to deactivate the User's account as a
                        result.
                    </p>
                    <h3>6.2. Managing User Content</h3>
                    <p>
                        Content created by the User may be published by the Service Provider on the public surfaces of the
                        Web Application after 14 days. This content can be seen by other users and visitors to the Web App
                        page. By default, other users may copy and modify this content. This can be changed in the task’s
                        share window. The Content will be listed until the User deletes it. Deleting a User Account will not
                        automatically delete the User Content!
                    </p>
                    <p>
                        By using the Service, you agree to waive any right to use any of the Content that you post on the
                        page and do not claim any benefit therefrom.
                    </p>
                    <h2>7. Advertisements on the site</h2>
                    <p>
                        Ads are displayed on the site to help its maintenance. It is provided by Google LLC (1600
                        Amphitheater Parkway, Mountain View, CA 94043 United States;{" "}
                        <a
                            className="link"
                            rel="noopener noreferrer"
                            target="_blank"
                            href="https://policies.google.com/privacy?hl=en"
                        >
                            for more information
                        </a>
                        ). Google uses cookies to help serve ads that appear on the site, such as sites that display Google
                        ads or participate in Google-approved ad networks. When a User visits a Google Partner site, a
                        cookie may be downloaded to the end user's browser. Google uses cookies to serve ads based on a
                        user's previous visits to the site or other sites. Google's advertising cookies allow Google and its
                        partners to serve ads to users based on their visits to the site and other sites on the Internet.
                        Users can opt out of personalized ads by visiting the Ads Preferences page or www.aboutads.info to
                        opt out of using third-party cookies for personalized ads.
                    </p>
                    <p>Last updated on 4th of April, 2020</p>
                </div>
            )}
        </StyledTerms>
    );
}

export default Terms;
